import React from "react";
import { DefaultToastContainer } from "react-toast-notifications";

const CustomToastContainer = (props) => {
  return (
    <DefaultToastContainer
      {...props}
      style={{
        zIndex: 9999,
        position: "fixed",
        top: "7%",              // pushes it down vertically
        left: "50%",             // starts in the middle of the screen
        transform: "translateX(-50%)", // centers it horizontally
        maxWidth: "90%",
        width: "auto",
        textAlign: "center",
        pointerEvents: "none",   // allows clicks to pass through (optional)
      }}
    />
  );
};

export default CustomToastContainer;
